import { Button, Form, Space } from "antd";

import React from "react";
import ReactToPrint from "react-to-print";

export default function FormButtons({
  loading,
  onSearch,
  onDownload,
  has_print = true,
  report,
  formItemLayout,
  additional_buttons = [],
}) {
  return (
    <Form.Item {...formItemLayout}>
      <Space>
        {onSearch && (
          <Button
            loading={loading?.search || false}
            onClick={() => {
              onSearch();
            }}
          >
            Search
          </Button>
        )}
        {onDownload && (
          <Button
            loading={loading?.download || false}
            onClick={() => {
              onDownload();
            }}
          >
            Download to Excel
          </Button>
        )}
        {has_print && (
          <ReactToPrint
            trigger={() => <Button type="primary">Print</Button>}
            bodyClass="print"
            content={() => report.current}
          />
        )}
        {additional_buttons.map((component) => component)}
      </Space>
    </Form.Item>
  );
}
